module.exports = require("@nestjs/jwt");